import { PermitFieldType } from '~/client/graph'

const formFieldsCaptionMap = {
  [PermitFieldType.InputText]: 'Text Input',
  [PermitFieldType.InputTextArea]: 'Text Input (Multiple Lines)',
  [PermitFieldType.InputNumber]: 'Number Input',
  [PermitFieldType.StartFinishDates]: 'Date and Time',
  [PermitFieldType.AdditionalDate]: 'Date',
  [PermitFieldType.Time]: 'Time',
  [PermitFieldType.Company]: 'Company',
  [PermitFieldType.Requester]: 'Requester',
  [PermitFieldType.Assignee]: 'Responsible',
  [PermitFieldType.Subscriber]: 'Additional Contact',
  [PermitFieldType.User]: 'User',
  [PermitFieldType.Location]: 'Location',
  [PermitFieldType.Equipment]: 'Equipment',
  [PermitFieldType.Select]: 'Dropdown',
  [PermitFieldType.Measure]: 'Measure (Number + Unit)',
  [PermitFieldType.Email]: 'Email',
  [PermitFieldType.PhoneNumber]: 'Phone Number',
  [PermitFieldType.Instructions]: 'List',
  [PermitFieldType.Checklist]: 'Checklist',
  [PermitFieldType.Question]: 'Question',
  [PermitFieldType.Divider]: 'Divider Line',
  [PermitFieldType.Section]: 'Section',
  [PermitFieldType.Subsection]: 'Subsection',
  [PermitFieldType.Text]: 'Plain Text',
  [PermitFieldType.File]: 'File or Photo',
  [PermitFieldType.Table]: 'Table',
  [PermitFieldType.LocationInformational]: 'Location',
  [PermitFieldType.EquipmentInformational]: 'Equipment',
  [PermitFieldType.Material]: 'Material - legacy',
  [PermitFieldType.MaterialInformational]: 'Material - legacy',
  [PermitFieldType.MaterialResource]: 'Material',
  [PermitFieldType.MaterialResourceInformational]: 'Material',
  [PermitFieldType.RichText]: 'Rich Text',
  [PermitFieldType.CompanyInformational]: 'Company',
  [PermitFieldType.LinkedWorkflow]: 'Linked Workflow',
  [PermitFieldType.Signature]: 'Signature',
  [PermitFieldType.InlineMedia]: 'Inline Media',
  [PermitFieldType.Activity]: 'Activity',
  [PermitFieldType.PrimaryActivity]: 'Activity',
}

export const getFieldTypeCaption = (type: PermitFieldType): string =>
  formFieldsCaptionMap[type] || type

export default formFieldsCaptionMap
